import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const VerifyEmail = () => {
  const { uid, token } = useParams();
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await axios.get(`/api/verify-email/${uid}/${token}/`);
        setMessage(response.data.message);
      } catch (err) {
        setError(true);
        setMessage(err.response?.data?.error || 'Erro ao verificar o e-mail.');
      }
    };

    verifyEmail();
  }, [uid, token]);

  return (
    <div className="verify-email-container">
      <h1>{error ? 'Erro' : 'Sucesso'}</h1>
      <p>{message}</p>
    </div>
  );
};

export default VerifyEmail;